import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const CheckoutForm = ({ order }) => {
    const [clientSecret, setClientSecret] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [processing, setProcessing] = useState(false);
    const stripe = useStripe();
    const elements = useElements()
    const { _id, productId, price, buyer, email } = order;

    useEffect(() => {
        fetch("https://recycle-zone-server-ten.vercel.app/create-payment-intent", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ price }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret));
    }, [price]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);

        if (card === null) {
            return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card
        });

        if (error) {
            toast.error(error.message);
        }

        setProcessing(true);

        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
            clientSecret,
            {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: buyer,
                        email: email
                    },
                },
            },
        );

        if (confirmError) {
            toast.error(confirmError.message)
            return;
        }
        // console.log('payment intent', paymentIntent)

        if (paymentIntent.status === "succeeded") {
            console.log('card info', card)

            const payment = {
                orderId: _id,
                productId,
                transactionId: paymentIntent.id,
                price,
                buyer,
                email,
            }

            fetch('https://recycle-zone-server-ten.vercel.app/payments', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payment)
            })
                .then(res => res.json())
                .then(data => {
                    if (data.acknowledged) {
                        toast.success('Your payment is successfully completed')
                        setTransactionId(paymentIntent.id)
                    }
                })
        }
        setProcessing(false);
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <CardElement
                    style={{
                        display: 'flex'
                    }}
                    options={{
                        style: {
                            base: {
                                ':-webkit-autofill': {
                                    color: '#fce883',
                                },
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',
                                color: 'black',
                                '::placeholder': {
                                    color: 'grey',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
                <div className='flex justify-center'>
                    <button className='btn btn-sm mt-4 md:mt-6 lg:mt-8 w-1/2' type="submit" disabled={!stripe || !clientSecret || processing}>
                        Pay
                    </button>
                </div>
            </form>
            {
                transactionId && <p>Your transaction ID is: <span className='font-bold'>{transactionId}</span></p>
            }
        </>
    );
};

export default CheckoutForm;